import './Loader.css';

/**
 * Same branded loader as shop.ammachekku.com — logo GIF with reveal animation.
 */
function Loader({ size = 150, logoSrc = `${process.env.PUBLIC_URL}/images/logo.gif` }) {
  return (
    <div className="loader-wrap" role="status" aria-live="polite" aria-label="Loading">
      <img
        src={logoSrc}
        alt=""
        className="loader-img"
        style={{ width: `${size}px`, height: 'auto' }}
      />
    </div>
  );
}

export default Loader;
